<div class="d-flex align-items-start gap-3 px-3 d-none">
    <!-- Title + Subtext -->
    <div>
    <h5 class=" text-white mb-1">
        {{ centre.title }}
    </h5>

    <p class="text-white-50 text-xxs mb-0">
        {{ centre.address }}
        <span v-if="centre.size"> · {{ centre.size }} GLA</span>
    </p>
    </div>

</div>
